import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { AdminManagerService } from "../services/admin-manager.service";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { DwConfigService, DwConfigServiceToken } from "@devwareapps/devware-cap";

@Injectable()
export class FitnessHttpInterceptor implements HttpInterceptor {

    constructor(private adminManagerService: AdminManagerService, private router: Router,
        @Inject(DwConfigServiceToken) private configService: DwConfigService,
    ) {

    }

    FITNESS_USER_TYPE_OVERRIDE = "fitness-user-type-override";

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: { [prop: string]: string } = {};

        if (!this.adminManagerService.canUseAdminProperties()) {
            return next.handle(request);
        }

        // Only apply to requests that are going to the API
        if (request.url.indexOf(this.configService.coreConfig.apiRoot) == -1) {
            return next.handle(request);
        }

        const fitnessUser = this.adminManagerService.getFitnessUser();

        headers[this.FITNESS_USER_TYPE_OVERRIDE] = fitnessUser?.UserTypeId?.toString() || '';

        request = request.clone({
            headers: request.headers,
            setHeaders: headers
        });

        return next.handle(request);
    }
}
